import { Routes, Route } from 'react-router-dom';
import './App.css';

import AuthProvider, { ProtectedRoute, useAuth } from './components/AuthContext';
import Layout from './layout/Layout';
import Login from './pages/Login';
import SignUp from './pages/Signup';
import UserPage from './pages/UserPage';
import SettingsPage from './pages/SettingsPage';
import TopicsExplorer from './pages/TopicsExplorer';
import TopicView from './pages/TopicView';
import ThoughtNavigator from './pages/ThoughtNavigator';
import TopOfMind from './pages/TopOfMindPage';
import TimelineViewer from './pages/TimelineViewer';
import HelpPage from './pages/HelpPage';
import DiscoverPage from './pages/DiscoverPage';

function App() {
  return (
    <AuthProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="login" element={ <Login /> } />
          <Route path="signup" element={ <SignUp /> } />
          <Route path="profile" element={ <ProtectedRoute> <UserPage /> </ProtectedRoute> } />
          <Route path="settings" element={ <ProtectedRoute> <SettingsPage /> </ProtectedRoute> } />
          <Route path="explore" element={ <TopicsExplorer /> } />
          <Route path="topic" >
            <Route index element={ <TopicView /> } />
            <Route path=":name" element={ <TopicView /> } />
          </Route>
          <Route path="mind" element={ <ProtectedRoute> <ThoughtNavigator /> </ProtectedRoute> } />
          <Route path="timeline" element={ <ProtectedRoute> <TimelineViewer /> </ProtectedRoute> } />
          <Route path="*" element={<NotFound />} />
          <Route path="help" >
            <Route index element={ <HelpPage /> } />
            <Route path=":page" element={ <HelpPage /> } />
          </Route>
        </Routes>
      </Layout>
    </AuthProvider>
  );
}

function Home() {
  const {userInfo} = useAuth()!;
  return ((userInfo) ? (
    <TopOfMind type={userInfo.top_type || 'personal'} />
  ) : (
    <DiscoverPage />
  ));
}

function NotFound() {
  return (
    <div>
      <h1> Sorry, desired page couldn't be found. </h1>
    </div>
  );
}

export default App;
